export default __webpack_public_path__ + "static/media/image-product.ba07d762.jpg";